import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { environment } from '../../../environments/environment.deploy';
import { getDecodedToken } from '../../jwt/auth.utils';

@Injectable({
  providedIn: 'root'
})
export class MixpanelService {

  constructor() {
    mixpanel.init(environment.mixpanelToken, { autocapture: true });
  }

  track(event: string, properties?: any) {
    mixpanel.track(event, properties);
  }

  identifyUserFromToken() {
  const decoded = getDecodedToken();
  if (decoded) {
    this.identify(decoded.email);
    this.setUserProperties({
      $email: decoded.email,
      name: decoded.name || '',
      key: decoded.key || '',
      lastLogin: new Date().toISOString(),
    });
  }
}

  identify(userId: string) {
    mixpanel.identify(userId);
  }

  setUserProperties(properties: any) {
    mixpanel.people.set(properties);
  }

  reset() {
    mixpanel.reset();
  }
}
